<form #searchStdByCampus="ngForm">
    <div class="row">

        <div class="col-lg-6 col-md-6 col-sm-6 ">
            <div class="label">District</div>
            <div>
                <select name="schoolDistrict" #schoolDistrict="ngModel" class="districtDdl" required
                [disabled]="(loggedInUser.accessLevel == enumAccessLevel.CAMPUSUSER&&schoolDistricts.length==1) || loggedInUser.accessLevel == enumAccessLevel.DISTRICTUSER || loggedInUser.accessLevel == enumAccessLevel.VIEWONLYUSER"
                [(ngModel)]="searchRequest.schoolDistrict" (change)="getCampus()">
                <option value="0" selected disabled>Select District</option>
                <option *ngFor="let item of schoolDistricts" [value]="item.policyNo">{{item.client}}</option>
            </select>
            </div>
            <div *ngIf="searchStdByCampus.submitted || schoolDistrict.touched" class="errorMessage">
                <div *ngIf=" searchRequest.schoolDistrict == 0 ">
                    Please select District Value from the Drop Down!
                </div>
            </div>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-4 ">
            <div class="label">Campus</div>
            <div>
                <select class="districtDdl" name="campus" #campus="ngModel" [(ngModel)]="searchRequest.campusID" required
                [disabled]="loggedInUser.accessLevel == enumAccessLevel.CAMPUSUSER&&campuses.length==1">
                <option value=0 selected disabled>Select Campus</option>
                <option *ngFor="let item of campuses" [value]="item.campusID">{{item.campusName}}</option>
            </select>
            </div>
            <div *ngIf="searchStdByCampus.submitted || campus.touched" class="errorMessage">
                <div *ngIf=" searchRequest.campusID == 0 ">
                    Please select Campus Value from the Drop Down!
                </div>
            </div>
        </div>
        <div class="col-lg-2 col-md-2 col-sm-2">
            <div class="mt-4"><button type="submit" class="searchBoxButton" (click)="Search()" type="submit">Search</button></div>
        </div>
    </div>
    <!-- <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-6 ">
            <div *ngIf="searchStdByCampus.submitted || schoolDistrict.touched" class="errorMessage">
                <div *ngIf=" searchRequest.schoolDistrict == 0 ">
                    Please select District Value from the Drop Down!
                </div>
            </div>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-4 ">
            <div *ngIf="searchStdByCampus.submitted || campus.touched" class="errorMessage">
                <div *ngIf=" searchRequest.campusID == 0 ">
                    Please select Campus Value from the Drop Down!
                </div>
            </div>
        </div>
        <div class="col-lg-2 col-md-2 col-sm-2 ">

        </div>
    </div> -->
</form>

<div
  class="container mt-1"
  *ngIf="isLoadingStudents">
  <div class="col text-center">
    <div class="spinner-border text-secondary my-4" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
</div>

<div
  *ngIf="dataSource.filteredData.length==0 && showMsg && !isLoadingStudents"
  class="noResult text-center">
  <h5 class="text-secondary my-4">No Students Found</h5>
</div>

<div
  class="tableTitleRow d-flex"
  [class.d-none]="isLoadingStudents"
  *ngIf="dataSource.filteredData.length > 0">
    <div class="table-title">
        Search Results
    </div>
    <div class="ms-auto" *ngIf="dataSource.filteredData.length>0">
        <button class="export" (click)="printExcel()">Export CSV</button>
    </div>
</div>

<div
  class="row mb-4"
  [class.d-none]="isLoadingStudents">
  <table mat-table [dataSource]="dataSource" aria-label="studnets data" *ngIf="dataSource.filteredData.length>0">
    <ng-container matColumnDef="firstName">
      <th mat-header-cell *matHeaderCellDef class="tableHeader"> First Name </th>
      <td mat-cell *matCellDef="let element"> {{element.firstName}} </td>
    </ng-container>
    <ng-container matColumnDef="lastName">
      <th mat-header-cell *matHeaderCellDef class="tableHeader"> Last Name </th>
      <td mat-cell *matCellDef="let element"> {{element.lastName}} </td>
    </ng-container>
    <ng-container matColumnDef="dateofBirth">
      <th mat-header-cell *matHeaderCellDef class="tableHeader"> Date Of Birth </th>
      <td mat-cell *matCellDef="let element" style="width: 105px;"> {{element.dob | date:'yyyy-MM-dd' }} </td>
    </ng-container>
    <ng-container matColumnDef="location">
      <th mat-header-cell *matHeaderCellDef class="tableHeader"> Location </th>
      <td mat-cell *matCellDef="let element"> {{element.campusName}} </td>
    </ng-container>
    <ng-container matColumnDef="memberid">
      <th mat-header-cell *matHeaderCellDef class="tableHeader"> Member ID </th>
      <td mat-cell *matCellDef="let element"> {{element.ssn}} </td>
    </ng-container>
    <ng-container matColumnDef="rosterStatus">
      <th mat-header-cell *matHeaderCellDef class="tableHeader"> Roster Status </th>
      <td mat-cell *matCellDef="let element" class="px-0" style="width: 115px;"> <span [ngClass]="element.cC_TransactionID?.includes('ROSTER') ? 'rosterAdded' : 'rosterNotAdded'"> {{ element.cC_TransactionID?.includes('ROSTER') ? 'Added' : 'Not Added'}} </span></td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef class="tableHeader"> Action </th>
      <td mat-cell *matCellDef="let element" style="width: 70px;" class="text-center">
        <button mat-icon-button class="viewButton" (click)="OpenStudentDetailsPopup(element)">
          <img src="./assets/images/eye.svg" alt="Unable to load image">
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <!--Draft paginator-->
  <!-- <div class="row d-flex paginator">
    <div class="col-lg-6 col-sm-6 col-md-6">
      <div class="row">
        <div class="col-lg-4 col-md-4 col-sm-4">
          <mat-form-field class="go-to-select">
            <mat-label>Go To Page:</mat-label>
            <mat-select [(ngModel)]="goTo" (selectionChange)="goToChange()">
              <mat-option *ngFor="let pageNumber of pageNumbers" [value]="pageNumber">{{pageNumber}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-4">

        </div>
        <div class="col-lg-4 col-md-4 col-sm-4">
          <span> Page {{selectedPageNumber}} of {{currenttotalPages}}</span>
        </div>
      </div>
    </div>
    <div class="col-lg-6 col-md-6 col-sm-6">
      <mat-paginator #srchStdByCmpsPaginator
                     [length]="dataSource.filteredData.length" [pageSize]="10"
                     (page)="onPaginateChange($event)"></mat-paginator>
    </div>



  </div> -->


</div>
